import { Button, SignOutButton } from '../components'
import { useAuth } from '../auth/AuthContext.js'

export default function PendingPage(): JSX.Element {
  const { email, refresh } = useAuth()
  return (
    <main id="main-content">
      <h1>Waiting for admin approval</h1>
      <p>
        You&rsquo;re signed in as <strong>{email ?? 'your school account'}</strong>. An
        administrator from your school still needs to assign you a role before you can use Study
        Decks.
      </p>
      <p>If you&rsquo;ve already been approved, click &ldquo;Refresh&rdquo; to check again.</p>
      <div style={{ display: 'flex', gap: 'var(--space-3)', marginTop: 'var(--space-4)' }}>
        <Button type="button" variant="secondary" onClick={() => void refresh()}>
          Refresh
        </Button>
        <SignOutButton />
      </div>
    </main>
  )
}
